import React from "react";
import usePricing from "./usePricing";
import Button from "../Button";
import { SmallBody } from "../TextStyles";
import { Flex } from "grid-styled";

const EnablePricingFooter = () => {
  const { generateToken, validateAndStoreToken, disablePricing, pricingEnabled } = usePricing();

  const enablePricing = () => {
    const token = generateToken();
    validateAndStoreToken(token);
  };

  if (process.env.REACT_APP_STAGE === "production") return null;

  return (
    <Flex flexDirection="column" alignItems="center" mt="4rem">
      {pricingEnabled ? (
        <Button onClick={disablePricing}>Disable Pricing</Button>
      ) : (
        <Button onClick={enablePricing}>Enable Pricing</Button>
      )}

      <SmallBody>
        The Enable / Disable Pricing button is only present on staging, for testing purposes.
      </SmallBody>
    </Flex>
  );
};

export default EnablePricingFooter;
